import { render } from "./ConfirmModal.vue?vue&type=template&id=845b4608&scoped=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&lang=js"

import "./ConfirmModal.vue?vue&type=style&index=0&id=845b4608&scoped=true&lang=css"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845b4608"]])

export default __exports__